"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var EyeShut = function EyeShut(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "eye-shut",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M4 1c1.81 0 3.14.97 3.93 2.84L8 4l-.07.16C7.14 6.03 5.81 7 4 7S.86 6.03.07 4.16L0 4l.07-.16C.86 1.97 2.19 1 4 1zm1.66 1.32v.03a.5.5 0 01-.04.08L3.49 6.11l.51.03h.2a.5.5 0 01.05-.16l1.9-3.28c-.16-.15-.32-.28-.49-.38zM4 1.86a.82.82 0 01-.07.16L1.98 5.4c.17.15.35.28.54.38l2.23-3.85A3.45 3.45 0 004 1.86zm2.8 1.72L5.52 5.77C6.13 5.42 6.63 4.84 7 4a5.56 5.56 0 00-.2-.42zM1 4l.3.58L2.73 2.1C2 2.42 1.43 3.05 1 4z"
  }), _react["default"].createElement("circle", {
    fill: color,
    cx: "4",
    cy: "4",
    r: "1"
  }));
};

EyeShut.defaultProps = {
  size: 8,
  color: '#444'
};
var _default = EyeShut;
exports["default"] = _default;